import React from "react"
import coverVideo from '../../videos/cover.mp4'

const Video = () => (
  <section className="py-20">
    <div className="container mx-auto px-5">
      <div style={{
        padding: `56.25% 0 0 0`,
        position: `relative`
      }}>
        <video 
          style={{ position: `absolute`, top: `0`, left: `0`, width: `100%`, height: `100%` }}
          src={coverVideo} autoPlay loop playsInline muted>
          <track default
            kind="captions"
            srcLang="en"
            src={coverVideo} />
              Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
    </div>
  </section>
)

export default Video